class Color {

    constructor({
                    name = '',
                    hexCode = '',
                } = {}) {

        this.name = name;
        this.hexCode = hexCode;
    }

    static get TOP_COLOR() {
        return [
            new Color({name: 'WHITE', hexCode: '#FFFFFF'}),
            new Color({name: 'BLACK', hexCode: '#000000'}),
            new Color({name: 'RED', hexCode: '#C01E13'}),
        ]
    }

    static get COLOR() {
        return [
            new Color({name: 'SILVER', hexCode: '#E0E0E0'}),
            new Color({name: 'BLUE', hexCode: '#151C4F'}),
            new Color({name: 'GREEN', hexCode: '#154F2C'}),
            new Color({name: 'GRAU', hexCode: '#91929A'}),
            new Color({name: 'BROWN', hexCode: '#624028'}),
            new Color({name: 'YELLOW', hexCode: '#F2DF2F'}),
        ]
    }


    toFirestore() {
        return {
            name: this.name,
            hexCode: this.hexCode
        }
    }

}

module.exports = Color;